/**
 * Sanitize API key input: remove BOM, zero-width chars, trim,
 * and treat single-character placeholders as empty.
 */
export function sanitizeKey(raw) {
  if (!raw || typeof raw !== 'string') return '';
  // Remove BOM and zero-width chars: \u200B-\u200D, \uFEFF
  const stripped = raw.replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
  if (!stripped) return '';
  // Treat obvious single-character placeholders as empty
  if (stripped.length === 1 && ['.', '•', '·'].includes(stripped)) return '';
  return stripped;
}
